import React, {useState} from 'react';
import {Button} from '@material-ui/core';
import {
  reduxAddDepot,
  reduxToggleSidePanel,
  reduxUpdateDepot,
} from 'appredux/actions';
import CheckIcon from 'components/CheckIcon/CheckIcon';
import {Route} from 'react-router-dom';
import {IDepot, ISupplierUserProfile} from 'constants/interfaces';
import {DepotForm} from 'components/DepotForm/DepotForm';
import {apiDepotSave} from 'constants/Api';
import {PermissionsService} from 'services/PermissionsService';
import {ESupplierUserPermissions} from 'constants/index';

const AddOrUpdateDepot = (props: {
  user: ISupplierUserProfile;
  depot?: IDepot;
}) => {
  const [depot, setDepot] = useState(props.depot);
  const [isLoading, setIsLoading] = useState(false);
  const [hasSuccessfullyCreatedDepot, setHasSuccessfullyCreatedDepot] =
    useState(false);

  const isAdding = !props.depot;

  const handleSubmit = (depot: IDepot) => {
    if (!canWrite) return;
    setIsLoading(true);
    apiDepotSave(depot)
      .then((depotUpdate) => {
        isAdding ? reduxAddDepot(depotUpdate) : reduxUpdateDepot(depotUpdate);
        setHasSuccessfullyCreatedDepot(true);
      })
      .catch((err) => {
        alert('Failed to update depot at the moment. Please try again later');
        console.error('Failed to add depot', err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleCancel = () => {
    reduxToggleSidePanel(false, null);
  };

  const permissions = new PermissionsService(props.user);
  const canWrite = permissions.hasPermission(
    ESupplierUserPermissions.DEPOT_WRITE,
  );

  if (hasSuccessfullyCreatedDepot) {
    return (
      <Route
        render={() => (
          <div className="side-panel-success-container">
            <div className="mid-section">
              <div className="success-gif">
                <CheckIcon />
              </div>
              <div className="success-msg">
                {isAdding
                  ? 'Depot added successfully'
                  : 'Depot updated successfully'}
              </div>
            </div>
            <div className="btn-container">
              {isAdding && (
                <Button
                  className="primary-btn alt-button"
                  type="submit"
                  variant="outlined"
                  disabled={isLoading}
                  onClick={() => {
                    setDepot(undefined);
                    setHasSuccessfullyCreatedDepot(false);
                  }}
                >
                  Add another depot
                </Button>
              )}
              <Button
                className="primary-btn"
                type="submit"
                variant="outlined"
                color="primary"
                disabled={isLoading}
                onClick={() => {
                  reduxToggleSidePanel(false, null);
                }}
              >
                View Depots
              </Button>
            </div>
          </div>
        )}
      />
    );
  }

  return (
    <DepotForm
      user={props.user}
      depot={depot}
      isLoading={isLoading}
      submitButtonTitle={isAdding ? 'Add' : 'Update'}
      onSubmit={handleSubmit}
      cancelButtonTitle={'Cancel'}
      onCancel={handleCancel}
      readonly={!canWrite}
    />
  );
};

export default AddOrUpdateDepot;
